<template>
    <div class="overlay" @click.self="closePopup">
      <div class="popup">
        <h2>{{ $t('RestoreFile.RestoreFromStorage') }}</h2>
        <div v-if="storedDate">
            <p>{{ $t('RestoreFile.SavedAt') }} {{ storedDate }}</p>
            <br>
            <strong>{{ $t('RestoreFile.Restore') }}</strong>
        </div>
        <div v-else>
            <p>{{ $t('RestoreFile.noData') }}</p>
        </div>
        <div class="button-group">
          <button v-if="storedDate" @click="restoreData">{{ $t('RestoreFile.Continue') }}</button>
          <button @click="closePopup">{{ $t('RestoreFile.Cancel') }}</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RestoreFile',
    data() {
      return {
        storedDate: null,
      };
    },
    mounted() {
      const storedData = localStorage.getItem('storedData');
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        this.storedDate = parsedData.savedAt || 'Datum nicht verfügbar';
      }
    },
    methods: {
      restoreData() {
        const storedData = localStorage.getItem('storedData');
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          this.$store.dispatch('updateEmailData', parsedData.emailData); // Vuex Store Update
          this.closePopup();
        }
      },
      closePopup() {
        this.$emit('close');
      },
    },
  };
  </script>
  
  <style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .popup {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 300px;
    text-align: left;
  }
  
  .button-group {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
  }
  
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button:not([disabled]) {
    background: var(--primary-color);
    color: white;
  }
  
  button:not([disabled]):hover {
    background: var(--primary-color);
  }
  </style>
  